import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/css/glocal.css'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);


import VueDND from 'awe-dnd'
// 添加至全局
Vue.use(VueDND)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
